import React from "react";
import { MarkdownContent } from "utils/markdown/markdown-content";

export const USPrivacy = () =>  <MarkdownContent path={require("../content/us-privacy.md")} title="App U.S. State Privacy Supplement" />;

